import React from 'react';
import { Box, Avatar, Typography, Divider } from '@mui/material';
import { toHTTPSURL } from '../../../utils';
import { useTileDimensions } from './hooks/useTileDimensions';
import MediaEditDeleteButtons from './MediaEditDeleteButtons';
import CircularProgress from '@mui/material/CircularProgress';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

interface DraggedPhotoOverlayProps {
  file: any;
  isShowDescriptions: boolean;
  isSmallDisplay: boolean;
}

export const DraggedPhotoOverlay: React.FC<DraggedPhotoOverlayProps> = ({
  file,
  isShowDescriptions,
  isSmallDisplay,
}) => {
  const { tileHeight, tileWidth, imageHeight } =
    useTileDimensions(isShowDescriptions);

  if (!file) return null;

  return (
    <Box
      sx={{
        width: tileWidth,
        height: `${tileHeight}px`,
        borderRadius: 2,
        overflow: 'hidden',
        backgroundColor: 'white',
        cursor: 'grabbing',
        boxShadow: '0px 0px 1px 4px rgba(128, 148, 214, 1)',
      }}
    >
      {/* Main Photo label if applicable */}
      {file.MEDIA_DISPLAY_ORDER === 0 && (
        <Typography
          sx={{
            zIndex: '2',
            position: 'absolute',
            color: 'white',
            ml: 1,
            mt: 1,
            px: 1,
            backgroundColor: 'red',
          }}
        >
          Main Photo
        </Typography>
      )}
      <Box sx={{ width: '100%', display: 'flex', justifyContent: 'end' }}>
        <CheckCircleIcon
          sx={{
            zIndex: '2',
            position: 'absolute',
            color: 'success.main',
            mr: 1,
            mt: 1,
            border: 1,
            borderRadius: 100,
            borderColor: 'white',
            backgroundColor: 'white',
          }}
        />
      </Box>

      <Avatar
        sx={{
          width: '100%',
          height: `${imageHeight}px`,
        }}
        variant="square"
        src={toHTTPSURL(file.MEDIA_URL_MEDIUM)}
      />

      {isShowDescriptions && (
        <Box
          sx={{
            px: 3,
            mt: 2,
            mb: 2,
            height: '30px',
            maxHeight: '30px',
            overflow: 'auto',
          }}
        >
          <Typography sx={{ fontSize: '.8rem' }}>
            {file.MEDIA_SHORT_DESCRIPTION}
          </Typography>
        </Box>
      )}

      <Divider className="bmls_divider" sx={{ mx: 3 }} />
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
        }}
      >
        <MediaEditDeleteButtons
          props={{
            isConfirmCancel: false,
            setIsConfirmCancel: () => {},
            editCallback: () => {},
            deleteCallback: () => {},
            disabledIcon: <CircularProgress size={16} />,
            isEditDisabled: false,
            disabledText: 'Generating...',
            isSmallDisplay,
          }}
        />
      </Box>
    </Box>
  );
};
